import { Box, Typography } from '@mui/material'

import { SuccessCheckIcon } from 'components/common'

interface DeliverySuccessProps {
  deliveryTime?: string
  collectionTime?: string
  completionType?: 'collection' | 'delivery'
}

const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  p: 2,
  textAlign: 'center',
}

const iconContainerStyles = {
  width: 60,
  height: 60,
  borderRadius: '50%',
  backgroundColor: '#D3F5C9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mb: 2,
}

const titleStyles = {
  fontSize: '24px',
  fontWeight: 600,
  color: '#2E7D32',
  mb: 1,
}

const subtitleStyles = {
  fontSize: '16px',
  fontWeight: 500,
  color: '#383838',
  mb: 2,
  letterSpacing: '0.15px',
}

const getSuccessMessage = (
  isCollection: boolean,
  collectionTime?: string,
  deliveryTime?: string,
) => {
  if (!deliveryTime) {
    return {
      title: 'Collection Complete',
      subtitles: [`Package successfully collected${collectionTime ? ` at ${collectionTime}` : ''}`],
    }
  }

  const deliverySubtitle = `Package successfully delivered at ${deliveryTime}`

  return {
    title: isCollection ? 'Delivery Complete' : 'Package Delivered',
    subtitles: isCollection
      ? [
          `Package successfully collected${collectionTime ? ` at ${collectionTime}` : ''}`,
          deliverySubtitle,
        ]
      : [deliverySubtitle],
  }
}

export const DeliverySuccess = ({
  collectionTime,
  deliveryTime,
  completionType = 'delivery',
}: DeliverySuccessProps) => {
  const { title, subtitles } = getSuccessMessage(
    completionType === 'collection',
    collectionTime,
    deliveryTime,
  )

  return (
    <Box sx={containerStyles}>
      <Box sx={iconContainerStyles}>
        <SuccessCheckIcon sx={{ fontSize: 44, color: '#2E7D32' }} />
      </Box>

      <Typography sx={titleStyles}>{title}</Typography>

      {subtitles.map((subtitle) => (
        <Typography key={subtitle} sx={subtitleStyles}>
          {subtitle}
        </Typography>
      ))}
    </Box>
  )
}
